import { Box, Grid, Paper, Typography } from '@mui/material';
import Followers from '../Company/ShareItems/Followers';

export default function MyAdvisorsEmptyState() {
  const liProps = {
    component: 'li',
    sx: {
      fontWeight: '400',
      fontSize: '15px',
      lineHeight: '33px',
      color: '#232B35',
      textAlign: 'left',
    },
  };
  return (
    <Grid container spacing={2} mt="-8px">
      <Grid item xxs={12} sm={6}>
        <Followers />
      </Grid>
      <Grid item xxs={12} sm={6}>
        <Paper
          elevation={1}
          sx={{
            height: '100%',
            padding: '48px 12px',
            borderRadius: '12px',
            width: '100%',
            boxShadow: 'none',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              mb: 2,
              fontWeight: '700',
              fontSize: '28px',
              lineHeight: '40px',
              color: '#232B35',
            }}
          >
            How to grow your Advisory Board
          </Typography>
          <Typography
            sx={{
              mb: 2,
              fontWeight: '400',
              fontSize: '20px',
              lineHeight: '40px',
              color: '#232B35',
            }}
          >
            Where should I use my advisory board URL?
          </Typography>
          <ul>
            <Typography {...liProps}>
              <strong>Share it in a social media post</strong> - Ask others to
              join your advisory board.
            </Typography>
            <Typography {...liProps}>
              <strong>Add it to your bios on social media</strong> - LinkedIn,
              Facebook, X, TikTok, and more.
            </Typography>
            <Typography {...liProps}>
              <strong>Invite existing customers to your board</strong> - Give
              them a behind-the-scenes look.
            </Typography>
            <Typography {...liProps}>
              <strong>Email it to team members & business associates</strong> -
              Keep them in the loop.
            </Typography>
            <Typography {...liProps}>
              <strong>Place your Advisory Board button on your website</strong>{' '}
              - Turn followers into advisors.
            </Typography>
            <Typography {...liProps}>
              <strong>Add it to your business email signature</strong> - Turn
              priority contacts into advisors.
            </Typography>
            <Typography {...liProps}>
              <strong>Use it anywhere you have traffic</strong> - Form deeper
              relationships with your audience.
            </Typography>
          </ul>
        </Paper>
      </Grid>
    </Grid>
  );
}
